import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dynamic%20cinematic%20collage%20of%20entertainment%20media%20with%20film%20strips%20music%20notes%20and%20colorful%20abstract%20waves%20on%20dark%20background%2C%20warm%20golden%20and%20crimson%20light%20streaks%2C%20modern%20media%20concept%2C%20vibrant%20and%20energetic%20composition%2C%20professional%20design%20with%20glowing%20elements&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="福利视频大全 - 精选资源"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6 text-center">
        <div className="animate-fade-in-up">
          <span className="inline-block px-3 py-1 bg-primary-500/90 text-background-50 text-xs font-medium rounded-full mb-4">
            每日更新 · 精选资源 · 免费观看
          </span>
        </div>
        <h1 className="animate-fade-in-up animation-delay-200 text-2xl md:text-4xl lg:text-5xl font-bold text-background-50 mb-4 font-heading max-w-3xl leading-tight">
          福利视频大全
          <span className="block text-primary-300 text-lg md:text-2xl lg:text-3xl mt-2 font-normal">
            精选资源免费看
          </span>
        </h1>
        <p className="animate-fade-in-up animation-delay-400 text-sm md:text-base text-background-200 max-w-xl mb-8 leading-relaxed">
          汇聚海量精选福利视频资源，涵盖影视、综艺、音乐、体育、动漫等热门内容，每日更新不断。收藏本页，随时畅享最新最全福利视频。
        </p>
        <div className="animate-fade-in-up animation-delay-600 flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/hot"
            className="px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-fire-line mr-1.5"></i>
            热门推荐
          </Link>
          <Link
            to="/category/all"
            className="px-6 py-2.5 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-sm font-medium hover:bg-background-50/30 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-grid-line mr-1.5"></i>
            浏览全部视频
          </Link>
        </div>

        <div className="animate-fade-in-up animation-delay-600 mt-10 flex items-center gap-6 text-background-200 text-xs md:text-sm">
          <div className="text-center">
            <span className="block text-lg md:text-xl font-bold text-accent-400">1000+</span>
            <span>精选视频</span>
          </div>
          <div className="w-px h-8 bg-background-50/20"></div>
          <div className="text-center">
            <span className="block text-lg md:text-xl font-bold text-accent-400">8+</span>
            <span>内容分类</span>
          </div>
          <div className="w-px h-8 bg-background-50/20"></div>
          <div className="text-center">
            <span className="block text-lg md:text-xl font-bold text-accent-400">每日</span>
            <span>持续更新</span>
          </div>
        </div>
      </div>
    </section>
  );
}